"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;
var _react = require("react");
var _Checkbox = _interopRequireDefault(require("../../Checkbox"));
var _ListItem = _interopRequireDefault(require("../../ListItem"));
var _ListItemDragHandler = _interopRequireDefault(require("../../ListItemDragHandler"));
var _ListItemIcon = _interopRequireDefault(require("../../ListItemIcon"));
var _ListItemSecondaryAction = _interopRequireDefault(require("../../ListItemSecondaryAction"));
var _ListItemText = _interopRequireDefault(require("../../ListItemText"));
var _Typography = _interopRequireDefault(require("../../Typography"));
var _styles = require("@mui/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["label", "secondaryLabel", "style", "className", "dense", "checkbox", "selected", "onClick", "secondaryAction", "icon", "divider", "scrollDivider", "dragHandler", "button", "actionCount", "disableGutters", "primaryTypographyProps", "labelWrap", "secondaryActionProps", "labelText", "secondaryLabelText"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = exports.useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {},
    item: {
      height: '100%'
    },
    itemContainer: {
      height: '100%'
    }
  };
});
var FitContent = function FitContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: {
      display: 'flex',
      flexDirection: 'row'
    },
    children: children
  });
};
var DataListItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var label = _ref2.label,
    secondaryLabel = _ref2.secondaryLabel,
    style = _ref2.style,
    className = _ref2.className,
    dense = _ref2.dense,
    checkbox = _ref2.checkbox,
    selected = _ref2.selected,
    onClick = _ref2.onClick,
    secondaryAction = _ref2.secondaryAction,
    icon = _ref2.icon,
    divider = _ref2.divider,
    scrollDivider = _ref2.scrollDivider,
    dragHandler = _ref2.dragHandler,
    button = _ref2.button,
    actionCount = _ref2.actionCount,
    disableGutters = _ref2.disableGutters,
    primaryTypographyProps = _ref2.primaryTypographyProps,
    _ref2$labelWrap = _ref2.labelWrap,
    labelWrap = _ref2$labelWrap === void 0 ? true : _ref2$labelWrap,
    _ref2$secondaryAction = _ref2.secondaryActionProps,
    secondaryActionProps = _ref2$secondaryAction === void 0 ? {} : _ref2$secondaryAction,
    labelText = _ref2.labelText,
    secondaryLabelText = _ref2.secondaryLabelText,
    props = _objectWithoutProperties(_ref2, _excluded);
  var classes = useStyles();
  var primaryTooltip = typeof label === 'string' ? label : '';
  var secondaryTooltip = typeof secondaryLabel === 'string' ? secondaryLabel : '';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    ref: ref,
    style: style,
    className: classes.root
  }, props), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItem["default"], {
      component: 'div',
      button: button,
      className: (0, _clsx["default"])(className, classes.item),
      divider: divider,
      scrollDivider: scrollDivider,
      onClick: onClick,
      ContainerComponent: 'div',
      style: {
        height: '100%'
      },
      actionCount: actionCount,
      ContainerProps: {
        className: classes.itemContainer
      },
      dense: dense,
      disableGutters: disableGutters,
      selected: !checkbox && selected,
      children: [dragHandler ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemDragHandler["default"], {
        children: dragHandler
      }) : null, checkbox ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon["default"], {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox["default"], {
          edge: 'start',
          checked: selected,
          tabIndex: -1,
          disableRipple: true
        })
      }) : null, icon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon["default"], {
        children: icon
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText["default"], {
        primary: /*#__PURE__*/(0, _jsxRuntime.jsx)(FitContent, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], _objectSpread(_objectSpread({
            noWrap: labelWrap,
            tooltipProps: {
              wrapper: true,
              wrapperProps: {
                style: {
                  minWidth: 0
                }
              }
            },
            tooltipText: primaryTooltip,
            disableTooltip: !primaryTooltip
          }, primaryTypographyProps), {}, {
            children: label
          }))
        }),
        secondary: secondaryLabel ? /*#__PURE__*/(0, _jsxRuntime.jsx)(FitContent, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
            noWrap: true,
            variant: 'body2',
            color: 'textSecondary',
            tooltipProps: {
              placement: 'bottom-start',
              wrapper: true,
              wrapperProps: {
                style: {
                  minWidth: 0
                }
              }
            },
            tooltipText: secondaryTooltip,
            disableTooltip: !secondaryTooltip,
            children: secondaryLabel
          })
        }) : null,
        disableTypography: true
      }), secondaryAction ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemSecondaryAction["default"], _objectSpread(_objectSpread({}, secondaryActionProps), {}, {
        children: secondaryAction
      })) : null]
    })
  }));
});
var _default = exports["default"] = DataListItem;